import { FaTelegram, FaWhatsapp, FaInstagram, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

export const WHATSAPP_CHANNEL_URL = 'https://whatsapp.com/channel/0029VbDYIPGAInPhqc8DFw3v';
export const WHATSAPP_BUTTON_CLASS = 'bg-success-dark hover:bg-success-dark/90 text-white';

export const socialPlatforms = [
  {
    name: 'Telegram',
    icon: FaTelegram,
    url: 'https://t.me/main_bet',
    enabled: true,
    buttonClass:
      'bg-primary hover:bg-primary-dark text-white',
    iconClass: 'text-[#229ED9]',
  },
  {
    name: 'WhatsApp',
    icon: FaWhatsapp,
    url: WHATSAPP_CHANNEL_URL,
    enabled: true,
    iconClass: 'text-[#128C7E] dark:text-[#25D366]',
  },
  {
    name: 'Instagram',
    icon: FaInstagram,
    url: 'https://www.instagram.com/mainbetcom/',
    enabled: true,
    iconClass: 'text-[#E4405F]',
  },
  {
    name: 'YouTube',
    icon: FaYoutube,
    url: '/',
    enabled: false,
    iconClass: 'text-[#FF0000]',
  },
  {
    name: 'X',
    icon: FaXTwitter,
    url: 'https://x.com/mainbetcom',
    enabled: true,
    iconClass: 'text-gray-900 dark:text-white',
  },
];

// Telegram invite link per page type (Telegram counts joins per link)
const telegramSlug = (placement = '') => {
  if (placement.startsWith('match')) return 'tg-match';
  if (placement.startsWith('guide')) return 'tg-guide';
  return 'tg-site';
};

/**
 * Telegram / WhatsApp go through /api/go so subscribe clicks are counted per placement
 * (backend/config/affiliateHops.js CHANNEL_LINKS); Instagram / X use their url below.
 */
export const getChannelHref = (channel, placement) => {
  const slug = channel === 'whatsapp' ? 'wa' : channel === 'telegram' ? telegramSlug(placement) : null;
  if (slug) return `/api/go/${slug}?${new URLSearchParams({ src: placement || 'unknown', ch: 'site' })}`;
  return socialPlatforms.find((p) => p.name.toLowerCase() === channel)?.url ?? null;
};

export const getEnabledSocialPlatforms = () =>
  socialPlatforms.filter((platform) => platform.enabled);

export const getTelegramPlatform = () =>
  socialPlatforms.find((platform) => platform.name === 'Telegram' && platform.enabled) ??
  null;
